import { useEffect, useState } from 'react'
import Layout from '../../components/Layout.jsx'
import { useApp } from '../../context/AppContext.jsx'
import { getWorkspaceDashboard } from './api.js'
import './dashboard.css'
import EventFeed from './EventFeed.jsx'

export default function WorkspaceDashboard() {
  const { selectedClient, activeOrganizationId, user } = useApp()
  const firstName = user?.name?.trim().split(/\s+/)[0]
  const greetingName = firstName && !firstName.includes('@') && firstName !== 'Usuário' ? firstName : null
  const clientId = selectedClient?.id || null
  const [state, setState] = useState({ loading: true, error: null })
  const [retry, setRetry] = useState(0)

  useEffect(() => {
    const controller = new AbortController()
    setState({ loading: true, error: null })
    getWorkspaceDashboard(clientId, controller.signal)
      .then(data => {
        if (!controller.signal.aborted) setState({ loading: false, error: null, data })
      })
      .catch(error => {
        if (!controller.signal.aborted) setState({ loading: false, error: error.message })
      })
    return () => controller.abort()
  }, [clientId, activeOrganizationId, retry])

  return (
    <Layout title="Dashboard" breadcrumb={['Visão geral']}>
      <div className="workspace-dashboard">
        {state.loading || state.error ? <section className="workspace-dashboard-empty" aria-live="polite" aria-busy={state.loading}>
          {state.loading ? <p>Carregando dashboard...</p> : state.error ? (
            <>
              <h2>Não foi possível carregar o dashboard</h2>
              <p role="alert">{state.error}</p>
              <button type="button" className="btn btn-secondary" onClick={() => setRetry(value => value + 1)}>Tentar novamente</button>
            </>
          ) : (
            <>
              <h2>Seu dashboard começa aqui</h2>
              <p>Os indicadores da sua operação serão reunidos neste espaço.</p>
            </>
          )}
        </section> : <EventFeed key={`${activeOrganizationId || ''}:${clientId || ''}`} clientId={clientId} greetingName={greetingName} />}
      </div>
    </Layout>
  )
}
